const { hostname } = window.location;
// eslint-disable-next-line no-nested-ternary
// export const env = /test|dev/.test(hostname)
//   ? 'dev'
//   : (hostname.indexOf('localhost') > -1 ? 'local' : 'prod');

// eslint-disable-next-line import/no-mutable-exports
let env = 'prod';
if (/localhost/.test(hostname)) {
  env = 'local';
} else if (/dev/.test(hostname)) {
  env = 'dev';
} else if (/dev1/.test(hostname)) {
  env = 'dev';
} else if (/test/.test(hostname)) {
  env = 'test';
}

export { env };
